import Vue from 'vue'
import axios from 'axios'
import { store } from '@/store/store'

let axiosinstance
fetch('/static/config.json').then(response => response.json()).then((response) => {
    axiosinstance = axios.create({
        baseURL: response.apiUrl,
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' }
    })
})

function waitForInstance () {
    return new Promise((resolve) => {
        function wait () {
            if (!axiosinstance) {
                setTimeout(() => {
                    wait()
                }, 10)
            } else {
                resolve()
            }
        }
        if (axiosinstance) {
            resolve()
        } else {
            wait()
        }
    })
}

export default {
    get (url, request) {
        return waitForInstance()
            .then(() => {
                return axiosinstance.get(url, { params: request })
                    .then((response) => Promise.resolve(response))
                    .catch((error) => Promise.reject(error))
            })
    },
    post (url, request) {
        return axiosinstance.post(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => {
                if (store.getters.userInfo.userId !== null) {
                    if (error.response.status === 401) {
                        Vue.prototype.$notify({
                            group: 'info',
                            type: 'error',
                            title: error.response.status,
                            text: 'Noget gik galt. Prøv at logge ind igen'
                        })
                        store.state.global.loginAgain = true
                    } else {
                        Vue.prototype.$notify({
                            group: 'info',
                            type: 'error',
                            title: error.response.status,
                            text: error.response.statusText
                            // text: 'Handlingen er mislykkedes, prøv igen'
                        })
                    }
                }
                return Promise.reject(error)
            })
    },
    patch (url, request) {
        return axiosinstance.patch(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    delete (url, request) {
        return axiosinstance.delete(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    downloadExcel (url, request) {
        return axiosinstance.post(url, request, { responseType: 'arraybuffer' })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    }
}



// WEBPACK FOOTER //
// ./src/store/api.js